import React from "react";

interface PitchTypeTagProps {
  pitchType: string;
  isHighlighted?: boolean;
}

export const PitchTypeTag: React.FC<PitchTypeTagProps> = ({
  pitchType,
  isHighlighted = false,
}) => {
  const pitchTypeStyles: Record<string, string> = {
    FF: "bg-blue-100 text-blue-800",
    SI: "bg-yellow-100 text-yellow-800",
    CU: "bg-orange-100 text-orange-800",
    SL: "bg-purple-100 text-purple-800",
    CH: "bg-green-100 text-green-800",
    CT: "bg-teal-100 text-teal-800",
    SP: "bg-cyan-100 text-cyan-800",
    KN: "bg-indigo-100 text-indigo-800",
    FC: "bg-red-100 text-red-800",
    SC: "bg-rose-100 text-rose-800",
    SV: "bg-violet-100 text-violet-800",
    CB: "bg-amber-100 text-amber-800",
    FB: "bg-sky-100 text-sky-800",
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium w-10 text-center ${
        pitchTypeStyles[pitchType] || "bg-gray-50 text-gray-800"
      } ${isHighlighted ? "ring-2 ring-orange-500" : ""}`}
      data-testid="pitch-type-tag"
    >
      {pitchType}
    </span>
  );
};
